import React, { ReactNode, Suspense } from 'react';
import { Box, IconButton, Modal, SxProps, Theme } from '@mui/material';
import { Close as CloseIcon } from '@mui/icons-material';
import classNames from 'classnames';
import { noop } from 'lodash';
import { ModalTitle } from './ModalTitle';

export const style: SxProps<Theme> = {
  bgcolor: 'background.paper',
  boxShadow: 24,
};

interface ModalProps {
  className?: string;
  title?: string;
  hideCloseButton?: boolean;
  onClose?: () => void;
  [key: string]: any;
}

interface ModalContainerProps {
  modal?: ReactNode;
  modalProps?: ModalProps;
  closeModal?: (props?: ModalProps) => void;
  children?: ReactNode;
}

export const ModalContainer: React.FC<ModalContainerProps> = ({
  modal,
  modalProps = {},
  closeModal = noop,
  children,
}) => {
  const { className, title, hideCloseButton, ...props } = modalProps;
  // Allow for modal to contain a render prop or children
  const modalContent = modal !== undefined ? modal : children;

  return (
    <Modal
      open={!!modalContent}
      onClose={() => closeModal(modalProps)}
      aria-labelledby="modal-modal-title"
      aria-describedby="modal-modal-description"
      data-cy="modal"
      {...props}
    >
      <Box
        sx={style}
        className={classNames(
          'sg-modal absolute p-2 md:p-8 flex w-19/20 xl:w-auto',
          className
        )}
      >
        <Box className="flex flex-1 relative">
          {!hideCloseButton && (
            <IconButton
              aria-label="Close Modal"
              className="button-close"
              onClick={() => closeModal(modalProps)}
              data-cy="close-modal"
            >
              <CloseIcon data-cy="CloseIcon" />
            </IconButton>
          )}
          <div className="flex-1 scroll-y">
            <Suspense fallback={'loading'}>
              <ModalTitle title={title} />
              {modalContent}
            </Suspense>
          </div>
        </Box>
      </Box>
    </Modal>
  );
};
